// extracted by mini-css-extract-plugin
export default {"flash":"Flash_flash__sjzhD","bulle":"Flash_bulle__cqQjQ","iconBulle":"Flash_iconBulle__XEryC","iconText":"Flash_iconText__9qrgH"};